// extracted by mini-css-extract-plugin
module.exports = {"container":"SidebarBottom_container__2zlKt"};